import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=7bbc820d&scoped=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&lang=js"
import style0 from "./ButtonIcon.vue?vue&type=style&index=0&id=7bbc820d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc820d",
  null
  
)

export default component.exports